import React from 'react'
import "./about.scss"

const About = () => {
    return (
        <>
            <section className="about-us">
                <div className="custom-container">
                    <div className="parent">
                        <div className="left-side">
                            <h4>About <span>Elinnovation</span></h4>
                            <p>Elinnovation Labs is a Web3 product and technology studio focused on building, scaling, and operating decentralized ecosystems. We partner with companies, founders, and organizations to deliver the full stack needed for modern blockchain products, combining product strategy, engineering, token economics, and operational excellence.
                                <br /><br />

                                Alongside our development and venture capabilities, we provide dedicated digital asset treasury and asset management services. Our team manages multi currency portfolios, digital assets, and traditional financial instruments, always in strict alignment with client policies and governance requirements.</p>
                        </div>
                        <div className="right-side">
                            <div className="multi-cards">
                                <div className="single">
                                    <img src="\assets\about\1.svg" alt="img" className='img-fluid' />
                                    <h6>Tech, Discipline & Transparency</h6>
                                    <p>Our methodology blends advanced technology, financial discipline, and transparent processes to ensure secure, responsible, and regulation aligned operations across all our services.</p>
                                </div>
                                <div className="single">
                                     <img src="\assets\about\2.svg" alt="img" className='img-fluid' />
                                    <h6>Expert-Led Innovation</h6>
                                    <p>We enable clients to innovate confidently, backed by an experienced team that executes with precision and accountability.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About
